/* eslint-disable @typescript-eslint/no-unused-vars */

(function (angular) {
  angular.module('xplenty-designer').factory('DesignerGoogleSpannerDestinationComponent', [
    '$rootScope',
    'DesignerBaseDatabaseDestinationComponent',

    function ($rootScope, DesignerBaseDatabaseDestinationComponent) {
      function DesignerGoogleSpannerDestinationComponent() {
        DesignerBaseDatabaseDestinationComponent.apply(this);
      }

      DesignerGoogleSpannerDestinationComponent.prototype = new DesignerBaseDatabaseDestinationComponent();

      DesignerGoogleSpannerDestinationComponent.prototype.getData = function () {
        const data = DesignerBaseDatabaseDestinationComponent.prototype.getData.call(this);

        return data;
      };

      DesignerGoogleSpannerDestinationComponent.prototype.setFormData = function (data) {
        this.setData(data);

        DesignerBaseDatabaseDestinationComponent.prototype.setFormData.call(this, data);
      };

      DesignerGoogleSpannerDestinationComponent.prototype.setData = function (data) {
        DesignerBaseDatabaseDestinationComponent.prototype.setData.call(this, data);
      };

      return DesignerGoogleSpannerDestinationComponent;
    },
  ]);
})(window.angular);
